import script from "./YouTubeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./YouTubeModal.vue?vue&type=script&setup=true&lang=js"

import "./YouTubeModal.vue?vue&type=style&index=0&id=5abdf800&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abdf800"]])

export default __exports__